import { RouteObject } from "react-router-dom";
import TicketListPage from "@/pages/tickets/TicketListPage";
import TicketDetailPage from "@/pages/tickets/TicketDetailPage";

export const ticketRoutes: RouteObject[] = [
  {
    path: "/tickets",
    children: [
      {
        index: true,
        element: <TicketListPage />,
      },
      {
        path: ":id",
        element: <TicketDetailPage />,
      }
    ],
  },
];
